const incomeStatmentJson = {
    "year": "",
    "open": true,
    "incomestatement": {
        "revenustream1": "",
        "revenustream2": "",
        "directcosts1": "",
        "directcosts2": "",
        "directcosts3": "",
        "directcosts4": "",
        "directcosts5": "",
        "managementandofficesalaries": "",
        "advertisingandmarketing": "",
        "irrecoverabledebts": "",
        "officeandoverheadcosts": "",
        "occupation": "",
        "professionalfees": "",
        "insurance": "",
        "repairandmaintenance": "",
        "publicservices": "",
        "interests": "",
        "depreciation": "",
        "nonoperatingprofit": "",
        "nonoperatingexpenses": "",
        "taxes": ""
    },
    "assets": {
        "currentassets": {
            "cash": "",
            "accounts": "",
            "stocks": "",
            "chargespaidinadvance": "",
            "shortterminvestments": "",
            "taxestoberecovered": "",
            "others": ""
        },
        "longtermassets": {
            "tangibleassets": {
                "ground": "",
                "buildings": "",
                "acquisitioncost": "",
                "accumulateddepreciation": ""
            },
            "equipmentassets": {
                "acquisitioncost": "",
                "accumlateddepreciation": ""
            },
            "automotiveassets": {
                "acquisitioncost": "",
                "accumlateddepreciation": ""
            },
            "officefurnitureassets": {
                "acquisitioncost": "",
                "accumlateddepreciation": ""
            },
            "hardwareassets": {
                "acquisitioncost": "",
                "accumlateddepreciation": ""
            },
            "rentalimprovementsassets": {
                "acquisitioncost": "",
                "accumlateddepreciation": ""
            },
            "amountreceivablefromrelatedparties": {
                "amountsreceivablefromxyzltd": "",
                "amountstobereceivedfromshareholders": ""
            }
        },
        "currentliabilities": {
            "accountspayable": "",
            "chargednotes": "",
            "deferredproducts": "",
            "customerdeposits": "",
            "governmentrebatesdue": "",
            "currentportionoflongtermdept": "",
            "currentportionofcapitalleasecontracts": "",
            "others": ""
        },
        "longtermliabilities": {
            "longtermdebt": "",
            "capitalleases": "",
            "amounttobepaidtorelatedparties": "",
            "amountstobepaidtoabcltd": "",
            "amountstobepaidtoshareholders": "",
            "otheramounts": ""
        },
        "equity": {
            "ordinaryactions": "",
            "preferredshares": "",
            "profitsnotdistributed": "",
            "openingbalanceofretainedearnings": "",
            "incomeforthecurrentperiod": "",
            "dividendspaid": "",
        }
    }
};

export default incomeStatmentJson;